// import SecureLS from "secure-ls";

export const storageKey = "bsBenefitOneInc";

// export const secureStorage = new SecureLS({ isCompression: false });

const initialStoreContent = localStorage.getItem(storageKey); //secureStorage.get(storageKey);

export const initialUnencryptedStorage = initialStoreContent
  ? JSON.parse(initialStoreContent)
  : {};
